"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mccList = {
    'Clínicas de Estética, Massagens': 7298,
    'Colégios, Cursos, Aulas Particulares': 8299,
    Dentistas: 8021,
    'Venda de Itens para Casa, Móveis, Materiais de Construção': 5039,
    Médicos: 8011,
    'Oficinas, Garagens, Estacionamentos': 7523,
    'Prestadores de outros serviços': 7299,
    'Personal Trainer, Academia, Clubes, Spa': 7997,
    'Petshop, Veterinário': 5995,
    'Pintura, Obras, Eletricistas, Marcenaria, Carpintaria': 5198,
    'Salão de Beleza, Cabeleireiro, Manicure': 7230,
    'Táxi, Motorista de Aplicativos ': 4121,
    'Venda de Alimentos Variados, Bebidas, Restaurantes': 5499,
    'Venda de Hardware, Computadores, Eletrônicos': 5072,
    'Venda de Outros Produtos': 5331,
    'Venda de Vestuário, Calçados, Moda': 5651,
};
exports.default = mccList;
//# sourceMappingURL=mcc.js.map